const TOKEN_SEGMENTS = ["join", "reset-password"];

function stripTokenSegments(value: string): string {
    let out = value;
    for (const segment of TOKEN_SEGMENTS) {
        out = out.replace(new RegExp(`/${segment}/[^/]+`, "i"), "");
    }
    return out;
}

function normalizeHash(value: string): string {
    if (value === "#") return "#/";
    return value;
}

/**
 * Extracts the token from a reset-password deep link. Accepts both a raw
 * `window.location.hash` ("#/reset-password/<token>") and the hash string the
 * embed.js handshake delivers ("/reset-password/<token>").
 */
export function extractResetPasswordToken(hash: string): string | null {
    const match = /^#?\/?reset-password\/([^/?&#]+)/.exec(hash);
    return match ? decodeURIComponent(match[1]) : null;
}

export function useTokenUrlCleanup() {
    function clearTokenUrls(): boolean {
        if (typeof window === "undefined") return false;

        const { pathname, search, hash } = window.location;
        const nextHash = normalizeHash(stripTokenSegments(hash)) || "#/";
        const nextUrl = `${pathname}${search}${nextHash}`;
        const currentUrl = `${pathname}${search}${hash}`;

        if (nextUrl === currentUrl) {
            return false;
        }

        window.history.replaceState({}, "", nextUrl);
        return true;
    }

    return { clearTokenUrls };
}
